export default __webpack_public_path__ + "static/feature-cover-inventory-0e3b934707ff3b08c6f3ec59905f5478.webp";